import React from 'react';

import { FullScreenLoading } from './fullscreenLoading';

export const Loading = () => <FullScreenLoading loading />;

export * from './fullscreenLoading';
